// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2AQf8","selected":"Chip_selected__1gXlh"};